import React from 'react';

export interface DonutSegment {
  label: string;
  value: number;
  color: string;
}

interface EmployeeDonutChartProps {
  segments: DonutSegment[];
  title?: string;
}

const buildGradient = (segments: DonutSegment[]) => {
  const total = segments.reduce((sum, segment) => sum + segment.value, 0) || 1;
  let current = 0;
  return segments
    .map((segment) => {
      const start = current;
      const size = (segment.value / total) * 100;
      current += size;
      return `${segment.color} ${start}% ${current}%`;
    })
    .join(', ');
};

export function EmployeeDonutChart({ segments, title = 'Shifts' }: EmployeeDonutChartProps) {
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);

  return (
    <div className="bg-navy-800 rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-white">{title}</h2>
      </div>

      {total === 0 ? (
        <div className="py-12 text-center text-sm text-navy-300">No shift data available yet.</div>
      ) : (
        <>
          <div className="relative flex items-center justify-center mb-6">
            <div
              className="relative w-56 h-56 rounded-full"
              style={{ background: `conic-gradient(${buildGradient(segments)})` }}
            >
              <div className="absolute inset-6 rounded-full bg-navy-800 flex flex-col items-center justify-center shadow-inner">
                <p className="text-sm text-navy-200 mb-1">Total</p>
                <p className="text-3xl font-bold text-white">{total.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4">
            {segments.map((segment) => (
              <div key={segment.label} className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: segment.color }}></div>
                <span className="text-sm text-navy-100">{segment.label}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
